import { motion } from "framer-motion";
import { Box } from "@mui/material";
import successIcon from "../assets/icons/success.png"; // Replace with your actual image
import { useState } from "react";
import ConfettiExplosion from "react-confetti-explosion";
import failureIcon from "./../assets/svg/failure.svg";

const BubbleEffect = ({ isSuccess }) => {
  const [isExploding, setIsExploding] = useState(true);

  const largeExplosion = {
    force: 0.8,
    duration: 5000,
    particleCount: 250,
    width: 1600,
  };
  const outerColor = isSuccess
    ? "rgba(76, 175, 80, 0.3)" // Green
    : "rgba(244, 67, 54, 0.3)"; // Red

  const innerColor = isSuccess
    ? "rgba(76, 175, 80, 0.5)"
    : "rgba(244, 67, 54, 0.5)";
  return (
    <Box
      position="relative"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      {/* Outer Bubble Animation */}
      <motion.div
        style={{
          position: "absolute",
          width: 128,
          height: 128,
          borderRadius: "50%",
          backgroundColor: outerColor,
        }}
        animate={{
          scale: [1, 1.35, 1],
          opacity: [0.8, 0.4, 0.8],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      {isExploding && isSuccess && (
        <ConfettiExplosion zIndex={9999} duration={5000} {...largeExplosion} />
      )}
      {/* Inner Bubble Animation */}
      <motion.div
        style={{
          position: "absolute",
          width: 100,
          height: 100,
          borderRadius: "50%",
          backgroundColor: innerColor,
        }}
        animate={{
          scale: [1, 1.25, 1],
          opacity: [0.7, 0.3, 0.7],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.5,
        }}
      />

      {/* Rotating Success Icon */}
      <motion.img
        src={isSuccess ? successIcon : failureIcon}
        alt="result Icon"
        style={{ height: "104px", width: "104px", zIndex: 1 }}
      />
    </Box>
  );
};

export default BubbleEffect;
